import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Table } from 'reactstrap';


class RevenueManagementServiceTab extends Component {

    constructor(props) {
        super(props);

        this.state = {
            year: this.props.year,
            values: {
            }
        }
        this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }

    componentDidMount = () => {
        this.props.log('RevenueManagementServiceTab.js/componentDidMount');
        this.addYears(this.props.yearList);
        this.props.setCallback((year) => this.setState({year: year}));
    }

    addYears = (yearList) => {
        this.props.log('RevenueManagementServiceTab.js/addYears (yearList)', yearList);
        let obj = {};
        yearList.forEach(year => {
            year = parseInt(year);
            obj[year] = { ...this.props.serviceGroup }.services.map(service => {
                return {
                    serviceId: service.serviceId,
                    columns: service.fields.map(field => {
                        return {
                            serviceColumnId: field.serviceColumnId,
                            months: [...new Array(12)].map((month,monthIndex) => {
                                if (field.revenue != null && field.revenue.findIndex(item => item.year === year && item.month === monthIndex+1) > -1) {
                                    return field.revenue.filter(item => item.year === year && item.month === monthIndex+1)[0].amount;
                                } else {
                                    return '';
                                }
                            })
                        }
                    })
                }
            })
        });
        this.setState({
            values: obj
        })
    }

    checkExists = (year, month, serviceId, serviceColumnId) => {
        this.props.info('RevenueManagementServiceTab.js/checkExists (year,month,serviceId,serviceColumnId)', year, month, serviceId, serviceColumnId);
        return this.state.values[year]
            .filter(service => parseInt(service.serviceId) === parseInt(serviceId))[0].columns
            .filter(column => parseInt(column.serviceColumnId) === parseInt(serviceColumnId))[0].months[month];
    }

    onChange = (year, month, serviceId, serviceColumnId, value) => {
        this.props.log('RevenueManagementServiceTab.js/checkExists (year,month,serviceId,serviceColumnId, value)', year, month, serviceId, serviceColumnId, value);
        let obj = { ...this.state.values };
        let serviceIndex = obj[year].findIndex(service => parseInt(service.serviceId) === parseInt(serviceId));
        let serviceColumnIndex = obj[year][serviceIndex].columns.findIndex(column => parseInt(column.serviceColumnId) === parseInt(serviceColumnId));
        obj[year][serviceIndex].columns[serviceColumnIndex].months[month] = (value !== '' ? value : '');
        this.setState({
            values: obj
        },() => {
            fetch('/api/revenue-management/', {
                method: 'POST',
                body: JSON.stringify({
                    clientId: this.props.clientId,
                    serviceId: serviceId,
                    serviceColumnId: serviceColumnId,
                    date: year+'/'+(month+1)+'/1',
                    amount: value !== '' ? value : null,
                    user: this.props.user,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.success) {
                    } else {
                        this.props.addToast('Unable to add amount.', 5, 'danger')
                    }
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        })
    }

    render = () => {
        this.props.info('RevenueManagementServiceTab.js/render');
        return (
            <Container fluid className='text-left'>
                {this.state.values[this.props.year] != null && this.props.serviceGroup.services.map(service => (
                    <Fragment key={service.serviceId}>
                        <Row className='mt-5'>
                            <Col>
                                <h3>{service.name}</h3>
                            </Col>
                        </Row>
                        <Row className='scrollH'>
                            <Col>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Service</th>
                                            <th>Standard Amount</th>
                                            {[...new Array(12)].map((month, index) => (
                                                <th key={index} className="tableCellPrice">{this.months[index]} {this.state.year}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {service.fields != null && service.fields.map(field => (
                                            <tr key={field.serviceColumnId}>
                                                <td className='text-left'>
                                                    {field.column}
                                                </td>
                                                <td>
                                                    {field.standard !== '' && field.standard != null ? '$' + field.standard : '--'}
                                                </td>
                                                {[...new Array(12)].map((month, index) => (
                                                    <td className="px-1" key={index}>
                                                        <Input
                                                            type="number"
                                                            onChange={(e) => this.onChange(this.state.year, index, service.serviceId, field.serviceColumnId, e.target.value)}
                                                            value={this.checkExists(this.state.year, index, service.serviceId, field.serviceColumnId)}
                                                        />
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Fragment>
                ))}
            </Container>
        );
    }
}

export default RevenueManagementServiceTab;
